define([
    'react',
    'lodash',
    './drop-down.less'
], function (React, _, DropDownLess) {
    'use strict';
    function repeatItem1(item, itemIndex) {
        return React.createElement('option', {
            'key': item.id,
            'value': item.id
        }, item.title);
    }
    return function () {
        return React.createElement('div', { 'className': this.getClass() }, React.createElement.apply(this, [
            'select',
            {
                'disabled': this.props.disabled,
                'onChange': this.onChange,
                'defaultValue': this.props.value
            },
            this.props.placeholder ? React.createElement('option', {
                'value': this.props.placeholder.id,
                'disabled': true
            }, this.props.placeholder.title) : null,
            _.map(this.props.collection, repeatItem1.bind(this))
        ]));
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/form-controls/drop-downs/drop-down/drop-down.rt
 ** module id = 200
 ** module chunks = 0
 **/